import OptimizelyFeature from './OptimizelyFeature'

export default OptimizelyFeature
// eslint-disable-next-line import/export
export * from './OptimizelyFeature'
